// extracted by mini-css-extract-plugin
export default {"l_TimeIcon_main":"TimeIcon_l_TimeIcon_main__Omhh3","l_TimeIcon_icon_img":"TimeIcon_l_TimeIcon_icon_img__ggcib"};